module.exports = "/_next/static/images/lovely-0706884c16f13726ff5d83dab0f13727.png";